/**
 * Public privacy policy page for the AppAI Browser Debug Chrome extension.
 * Route: /privacy/browser-extension (no layout, no login required).
 */

import React from 'react';
import {
  BROWSER_EXTENSION_POLICY,
  BROWSER_EXTENSION_POLICY_SECTIONS,
  type PolicySection,
} from './browserExtensionPrivacyContent';

const PolicySectionBlock: React.FC<{ section: PolicySection }> = ({ section }) => (
  <section className="mt-8">
    <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-white">{section.title}</h2>
    {section.paragraphs?.map((text) => (
      <p key={text} className="mb-3 leading-relaxed text-gray-700 dark:text-slate-300">
        {text}
      </p>
    ))}
    {section.bullets && (
      <ul className="list-disc space-y-2 pl-6 text-gray-700 dark:text-slate-300">
        {section.bullets.map((text) => (
          <li key={text} className="leading-relaxed">
            {text}
          </li>
        ))}
      </ul>
    )}
  </section>
);

export const BrowserExtensionPrivacyPage: React.FC = () => (
  <main className="min-h-screen bg-slate-50 px-4 py-10 dark:bg-slate-900 md:py-16">
    <article className="mx-auto max-w-3xl rounded-xl border border-gray-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-800 md:p-10">
      <p className="text-sm font-medium text-blue-500">{BROWSER_EXTENSION_POLICY.subtitle}</p>
      <h1 className="mt-1 text-3xl font-bold text-gray-900 dark:text-white">{BROWSER_EXTENSION_POLICY.title}</h1>
      <p className="mt-3 text-sm text-gray-500 dark:text-slate-400">
        Effective date: {BROWSER_EXTENSION_POLICY.effectiveDate} · Publisher: {BROWSER_EXTENSION_POLICY.publisher}
      </p>
      {BROWSER_EXTENSION_POLICY_SECTIONS.map((section) => (
        <PolicySectionBlock key={section.title} section={section} />
      ))}
      <section className="mt-8">
        <h2 className="mb-3 text-xl font-semibold text-gray-900 dark:text-white">10. Contact</h2>
        <a
          href={`mailto:${BROWSER_EXTENSION_POLICY.contactEmail}`}
          className="text-blue-500 hover:underline dark:text-blue-400"
        >
          {BROWSER_EXTENSION_POLICY.contactEmail}
        </a>
      </section>
    </article>
  </main>
);
